
namespace TabAurous.HR {
    import fld = LeavePolicyDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class LeavePolicyDetailsEditor extends _Ext.GridEditorBase<LeavePolicyDetailsRow> {
        protected getColumnsKey() { return 'HR.LeavePolicyDetails'; }
        protected getDialogType() { return LeavePolicyDetailsDialog; }
        protected getLocalTextPrefix() { return LeavePolicyDetailsRow.localTextPrefix; }


        private pendingChanges: Q.Dictionary<any> = {};
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            
        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
             
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this); 
            Q.first(columns, x => x.field === fld.AllocatedDays).format = int;
 
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }
        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.AllocatedDays) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }   
            else {
                value = text;
            }

        
            // *** Set Department ***
            if (field === fld.AllocatedDays && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh(); 

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion

        getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: 'Select Leave Type',
                onClick: () => {
                    var grid = LeaveTypeSelectGrid;
                    var self = this;
                    Common.StockSelectGrid
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Leave Type"
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n != null) });
                        selectedItems2.forEach(function (value: LeaveTypeRow) {
                            var newleave: LeavePolicyDetailsRow = {
                                LeaveTypeId: value.LeaveTypeId,
                                LeaveTypeCode: value.LeaveTypeCode,
                                AllocatedDays:0
                            }
                            newleave[self.getIdProperty()] = "`" + self.nextId++;

                            self.view.addItem(newleave);
                        });
                         
                    }

                    pickerDialog.dialogOpen();
                }
            })
            return buttons;
        }
    }
}